import {useSelector} from "react-redux";
import PageNotFound from "./PageNotFound";

export default function ProtectedPage({children,premissionFn=()=>false}){
    const user = useSelector(state=>state.userReducer.user);
    if(premissionFn(user)){
        return children;
    }
    return <PageNotFound/>
}